import './index.scss';

import PromiseModal from 'components/modals/promise_modal';
import ActivityComment from '../activity_comment';
import ActivityCommentsList from '../activity_comments_list';
import AbuseReportModal from 'components/modals/abuse_report_modal';
import {handleApiError} from 'utils/api_error_handler';

export default class Activity {
  constructor(activity) {
    if (activity.activityInstance) return;

    this.$activity = $(activity);
    this.activityId = activity.dataset.activityId;
    this.activityHasComments = activity.dataset.activityHasComments;
    this.activityCommentsCount = activity.dataset.activityCommentsCount;
    this.$dates = $('.js-activity-datetime', this.$activity);
    // This is disabled for now
    // this.$updateButton = $('.js-activity-update', this.$activity);
    this.$deleteButton = $('.js-activity-delete', this.$activity);
    this.$reportButton = $('.js-activity-report', this.$activity);
    this.$commentTextarea = $('.js-activity-comment-textarea', this.$activity);
    this.$commentsLoadButton = $('.js-activity-comments-load-btn', this.$activity);
    this.$commentPublishButton = $('.js-activity-comment-publish-btn', this.$activity);
    this.$commentsThread = $('.js-activity-comments-thread', this.$activity);
    this.commentSelectorClass = '.js-activity-comment';

    this.bindAll();

    activity.activityInstance = this;
  }

  /**
   *
   * Activity API
   * publish | delete | report | update (disabled)
   *
   */
  static publish(message) {
    return Thor.Activity.create_and_render(
      {},
      {
        data: {
          activity: {
            message
          },
          component_name: 'timeline/activity'
        }
      });
  }

  static delete(activityId = this.activityId) {
    return new Promise((resolve, reject) => {
      PromiseModal.call({
        question: 'Tem certeza que deseja deletar essa publicação?',
        modalType: 'danger'
      }, res => {
        if (res) {
          Thor.Activity
            .delete({id: activityId})
            .then(response => resolve(response))
            .catch((err) => reject(err));
        } else {
          reject('Usuário cancelou a ação');
        }
      });
    });
  }

  static report(activityId, reason) {
    return Thor.Activity.report_abuse(
      {
        id: activityId
      }, {
        data: {
          text: reason
        }
      });
  }

  // This is disabled for now
  // static update(activityId = this.activityId, message) {
  //   return new Promise((resolve, reject) => {
  //     Thor.Activity
  //       .update({
  //         id: activityId
  //       }, {
  //         data: {
  //           activity: {
  //             message
  //           },
  //           component_name: 'timeline/activity'
  //         }
  //       })
  //       .then(response => resolve(response))
  //       .catch((err) => reject(err));
  //   });
  // }

  /**
   *
   * Activity logic for Comments
   * Bind Publish Comment Button | Bind Load Comments Button | Bind Comment Textarea
   *
   */
  fetchComments(firstLoad = true, page = 1, cb) {
    const commentListLoaded = this.$activity.data('activity-comments-list-loaded');

    if (this.activityHasComments && (!firstLoad || !commentListLoaded)) {
      this.$commentsLoadButton.addClass('loading').attr('disabled', 'disabled');

      ActivityCommentsList.getList(this.activityId, page)
        .then((html) => {
          this.$commentsLoadButton.removeClass('loading')
            .slideUp(200, () => {
              this.$commentsThread
                .append(html)
                .find(this.commentSelectorClass)
                .toArray()
                .forEach(comment => new ActivityComment(comment));

              this.$activity.attr('data-activity-comments-list-loaded', true);

              if (cb && typeof cb === 'function')
                cb(true);
            });
        })
        .catch((err) => {
          console.log(err);
          this.$commentsLoadButton.removeClass('loading').attr('disabled', false);
          this.$activity.attr('data-activity-comments-list-loaded', false);

          if (cb && typeof cb === 'function')
            cb(false);
        });
    } else {
      this.$activity.attr('data-activity-comments-list-loaded', true);
      this.$commentsLoadButton.removeClass('loading');
    }
  }

  bindCommentsLoadButton() {
    this.$commentsLoadButton
      .off('click.activity')
      .on('click.activity', (e) => {
        e.preventDefault();
        this.fetchComments();
      });
  }

  bindCommentsLoadMoreButton() {
    this.$activity
      .off('click.activity', '.js-activity-comments-load-more-btn')
      .on('click.activity', '.js-activity-comments-load-more-btn', (e) => {
        e.preventDefault();

        const $btn = $(e.currentTarget);
        $btn.addClass('loading');

        const page = $btn.data('next-page');
        this.fetchComments(false, page, success => {
          if (success) {
            $btn.parent().remove();
          } else {
            $btn.removeClass('loading');
          }
        });
      });
  }

  bindCommentPublishButton() {
    this.$commentPublishButton.on('click', () => {
      this.$commentPublishButton.attr('disabled', 'disabled');

      ActivityComment.publish(this.$commentTextarea.val(), this.activityId)
        .then(response => {
          const count = Number(this.$activity.data('activity-comments-count'));
          this.$activity.attr('data-activity-comments-count', count + 1);
          this.$commentsThread.append(response.data);
          const addedComment = $(this.commentSelectorClass, this.$commentsThread).last().get(0);
          (new ActivityComment(addedComment));
          this.$commentTextarea.val('').removeClass('loading');
          this.$commentPublishButton.attr('disabled', false);
          this.$commentTextarea.get(0).dispatchEvent(new Event('autosize:update'));
        })
        .fail(({response}) => {
          this.$commentPublishButton.attr('disabled', false);
          handleApiError('Ops! Não foi possível criar o seu comentário nesse momento!', response);
        });
    });
  }

  bindCommentTextarea() {
    autosize(this.$commentTextarea.get(0));
    this.$commentTextarea.keyup(() => {
      this.$commentTextarea.val().length > 2 ?
        this.$commentTextarea.addClass('submitabble') :
        this.$commentTextarea.removeClass('submitabble');
    });
  }

  /**
   *
   * Activity User Actions
   * Delete | Report | Update (disabled)
   *
   */
  bindActivityDeleteButton() {
    if (!this.$deleteButton) return;

    this.$deleteButton.on('click', e => {
      e.preventDefault();

      this.constructor.delete(this.activityId, this.parentCommentId, this.replyId)
        .then(() => {
          this.$activity.slideUp(300, () => this.$activity.remove());
        })
        .catch(err => console.log(err));
    });
  }

  bindActivityReportButton() {
    if (!this.$reportButton) return;

    this.$reportButton.on('click', e => {
      e.preventDefault();
      AbuseReportModal.openForTimelineActivity({activityId: this.activityId});
    });
  }

  // This is disabled for now
  // TODO : refactor this to trigger a modal that receives a message to update the activity
  // bindActivityUpdateButton() {
  //   if(!this.$updateButton) return;

  //   this.$updateButton.on('click', e => {
  //     e.preventDefault();
  //     const message = 'testing update';

  //     this.constructor.update(this.activityId, this.parentCommentId, this.replyId, message)
  //       .then(response => console.log(response))
  //       .catch(err => console.log(err));
  //   });
  // }

  /**
   *
   * ActivityComment Extras
   * Moment humanized dates
   *
   */
  bindDates() {
    this.$dates.toArray().forEach(date => {
      date.innerHTML = moment(date.getAttribute('datetime'), moment.ISO_8601).locale('pt-br').fromNow();
    });
  }

  bindAll() {
    this.bindActivityDeleteButton();
    this.bindActivityReportButton();
    // This is disabled for now
    // this.bindActivityUpdateButton();
    this.bindCommentsLoadButton();
    this.bindCommentsLoadMoreButton();
    this.bindCommentPublishButton();
    this.bindCommentTextarea();
    this.bindDates();
  }
}
